// extracted by mini-css-extract-plugin
export default {"small":"Separator_small__NTSn8","medium":"Separator_medium__EEG+W","large":"Separator_large__3irjo","xlarge":"Separator_xlarge__CwkUN"};